export const BASE = "base";
export const BIPP = "bipp";
export const BUILDING_SITE = "buildingSite";
export const CLIENT_NAME = "clientName";
export const COLOR_STATS_TYPE = "color_stats_type";
export const CONSUMPTION_TYPE = "consumptionType";
export const CUSTOMER = "customer";
export const DATE = "date";
export const DATE_FROM = "dateFrom";
export const DATE_TO = "dateTo";
export const FANDECK = "fandeck";
export const FORMULA = "formula";
export const FORMULA_CODE = "formulaCode";
export const MONTH_DAYS = "monthDays";
export const MORE_INFO = "moreInfo";
export const MORE_INFO_INTERNAL = "moreInfoInternal";
export const OPERATOR = "operator";
export const PACKAGE = "package";
export const PACKAGE_COUNT = "packageCount";
export const PRODUCT = "product";
export const STATUS = "status";
export const WEEK_DAYS = "weekDays";

export const LABORATORY = "laboratory";
export const PLASTER_SMALL = "plasterSmallCanSize";
export const PLASTER_BIG = "plasterBigCanSize";
export const COATING = "coating";
export const ALL = "all";
